import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import ReactPolygonDrawer from '../../../components/fields/Polygon/PolygonDrawer';

export default function CameraZoneFrom(props) {
  const {
    camera = null,
    width = 0,
    height = 0,
    selectZonePolygon = () => {},
    polygon = [],
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const [tempPolygon, setPolygon] = useState([]);
  useEffect(() => setPolygon(polygon), [polygon]);
  if (!camera) return null;
  const onFinish = coordinates => {
    setPolygon(coordinates.map(c => ([c.x / width, c.y / height])));
  };
  const onSelect = () => {
    selectZonePolygon(tempPolygon);
  };
  const coordinates = tempPolygon.map(p => ({ x: p[0] * width, y: p[1] * height }));
  return (
    <>
      <div className="polygon-drawer-wrapper">
        <ReactPolygonDrawer key={coordinates} width={width} height={height} onFinish={onFinish} coordinates={coordinates} />
      </div>
      {/* <div className="camera-polygon"> */}
      {/*  <Icons customIcon icon="polygon" /> */}
      {/* </div> */}
      <div className="zone-edit-buttons">
        <Button variant="secondary" onClick={onSelect}><Icons customIcon width={22} height={22} icon="zones" />{formatMessage({ id: 'zone.set' })}</Button>
      </div>
    </>
  );
}
